import { createAction, props } from '@ngrx/store';
import { OrganizationInterfaceWithId } from '@sk/sk-interfaces';


export const getCurrentOrganization = createAction('[Organization] Get Current Organization');

export const getCurrentOrganizationSuccess = createAction('[Organization] Get Current Organization Success',
  props<{ organization: OrganizationInterfaceWithId }>()
);
export const getCurrentOrganizationError = createAction('[Organization] Get Current Organization Error',
  props<{ error: any }>()
);


export const setCurrentOrganizationId = createAction(
  '[Organization] set Current Organization Id',
  props<{ organizationId: string }>()
);


export const setCurrentOrganizationIdSuccess = createAction(
  '[Organization] set Current Organization Id Success',
  props<any>()
);

export const setCurrentOrganizationIdFailure = createAction(
  '[Organization] set Current Organization Id Failure',
  props<{ error: any }>()
);


// UPDATE ORGANIZATION
export const updateOrganization = createAction(
  '[Organization] update',
  props<{
    id: string,
    changes: OrganizationInterfaceWithId
  }>()
);

export const updateOrganizationSuccess = createAction(
  '[Organization] update success',
  props<any>()
);

export const updateOrganizationError = createAction(
  '[Organization] update failed',
  props<{ error: Error }>()
);


export const getFireStoreOrganization = createAction(
  '[Organization] get organization',
  props<{ organizationId: string }>()
);


export const getFireStoreOrganizationError = createAction(
  '[Organization] error at get Organization',
  props<{ error: Error }>()
);


export const fromFireStoreAddOrganization = createAction(
  '[Organization] added by Firestore',
  props<{ organization: OrganizationInterfaceWithId }>()
);


export const fromFireStoreModifyOrganization = createAction(
  '[Organization] modified by Firestore',
  props<{ organization: OrganizationInterfaceWithId }>()
);
export const fromFireStoreRemoveOrganization = createAction(
  '[Organization] removed by Firestore',
  props<{
    id: string,
  }>()
);



